import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { FolderOpen, ChevronDown, Pencil, Trash2, Plus } from 'lucide-react';

export function CategoryManager({ categories, onUpdate, onDelete, onAdd }) {
  const [showCategories, setShowCategories] = useState(false);
  const [editingCat, setEditingCat] = useState(null);

  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-sm mb-6">
      <button
        onClick={() => setShowCategories(!showCategories)}
        className="w-full flex items-center justify-between p-4 text-left hover:bg-zinc-800/50 transition-colors"
        data-testid="toggle-categories"
      >
        <div className="flex items-center gap-2">
          <FolderOpen className="h-4 w-4 text-[#78BE20]" />
          <span className="text-white font-medium text-sm">Categories</span>
          <span className="text-zinc-500 text-xs">({categories.length})</span>
        </div>
        <ChevronDown className={`h-4 w-4 text-zinc-400 transition-transform ${showCategories ? 'rotate-180' : ''}`} />
      </button>
      {showCategories && (
        <div className="border-t border-zinc-800 p-4">
          <div className="space-y-2">
            {categories.map(cat => (
              <div key={cat.id} className="flex items-center gap-2" data-testid={`category-${cat.id}`}>
                {editingCat?.id === cat.id ? (
                  <>
                    <Input
                      value={editingCat.name}
                      onChange={(e) => setEditingCat({ ...editingCat, name: e.target.value, slug: e.target.value.toLowerCase().replace(/\s+/g, '-') })}
                      className="flex-1 h-8 bg-zinc-800 border-zinc-700 text-sm"
                    />
                    <Input
                      value={editingCat.slug}
                      onChange={(e) => setEditingCat({ ...editingCat, slug: e.target.value })}
                      className="w-40 h-8 bg-zinc-800 border-zinc-700 text-sm text-zinc-400"
                      placeholder="slug"
                    />
                    <Button size="sm" className="h-8 bg-[#78BE20] text-black hover:bg-[#65a31b]" onClick={() => { onUpdate(cat.id, editingCat); setEditingCat(null); }}>Save</Button>
                    <Button size="sm" variant="outline" className="h-8 border-zinc-700" onClick={() => setEditingCat(null)}>Cancel</Button>
                  </>
                ) : (
                  <>
                    <span className="flex-1 text-white text-sm">{cat.name}</span>
                    <span className="text-zinc-600 text-xs font-mono">{cat.slug}</span>
                    <Button variant="ghost" size="sm" className="h-7 px-2 text-zinc-400 hover:text-white" onClick={() => setEditingCat({ ...cat })}>
                      <Pencil className="h-3 w-3" />
                    </Button>
                    <Button variant="ghost" size="sm" className="h-7 px-2 text-zinc-400 hover:text-red-400" onClick={() => onDelete(cat.id)}>
                      <Trash2 className="h-3 w-3" />
                    </Button>
                  </>
                )}
              </div>
            ))}
          </div>
          <Button
            size="sm"
            variant="outline"
            className="mt-3 border-zinc-700 text-zinc-400"
            onClick={onAdd}
          >
            <Plus className="h-3 w-3 mr-1" /> Add Category
          </Button>
        </div>
      )}
    </div>
  );
}
